<template>
  <div class="selectTeacher">
    <el-card class="box-card">
      <div style="text-align:center;">      
        <h4>预约成功</h4>
        <i class="el-icon-circle-check" style="margin:10px 0 20px;font-size:60px;color:#FE8087;"></i>
      </div>
      <AppointInfo :appoint="appoint"></AppointInfo>
    </el-card>

    <p class="text-right">
      <el-link type="danger" @click="reminderShow = true">温馨提示</el-link>
    </p>
    <Reminder v-if="reminderShow" @close-reminder="closeReminder"></Reminder>
    <br>
    <el-button type="primary" round style="width: 100%" @click="goback">返回</el-button>    
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { diffAppointStart, diffDays } from "@/utils/date.js";
import { parseAppointStatus,getStatusClass } from "@/utils/status.js";
import AppointInfo from '@/components/appointInfo'
import Reminder from '../components/reminder.vue';
export default {
  components: {
    AppointInfo,
    Reminder,
  },
  data() {
    return {
      reminderShow: false,
      cancelAppoint: false,
      appoint: {},
      scheduleId: null,
      pathfrom: null,      
      memo: '',
      //
      diffAppointStart,
      diffDays,
      parseAppointStatus,
      getStatusClass,      
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },    
  created() {
    if (this.$route.query.scheduleId) {
      this.scheduleId = this.$route.query.scheduleId;
      this.getSchedule();
    }
    else{
      this.$alert('请求url缺乏必须的参数',  {confirmButtonText: '确定',showClose: false,});        
    }
    this.pathfrom = this.$route.query.pathfrom;    
  },  
  mounted() {
    document.title = '预约成功'
  },
  methods: {
    goback() {
      this.$router.push(this.pathfrom?this.pathfrom:'home');
    },
    getSchedule(){
      let url = "/constub/getSchedule";
      let data = { token: this.student.token, scheduleId: this.scheduleId };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.appoint = res.data;
          if(this.appoint.status != 20 && this.appoint.status != 40){  //判断状态是否正确
            this.$message({message: '预约状态已变更，跳转回原路径',type: "error",});
            this.$router.push(this.pathfrom?this.pathfrom:'home')
          }
        } else {
          this.$alert(res.result.message,  {
            confirmButtonText: '确定',
            showClose: false,
          });  
        }
      });     
    },    
    closeReminder(){
      this.reminderShow = false;
    }, 
  },
};
</script>


<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}

.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
p {
  line-height: 24px;
}
.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
